<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <input [formControl]="control" matInput type="datetime-local" matIconSuffix/>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }

  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-check" (click)="stopEditing()"></mat-icon>
  </div>
</div>
